<template lang="pug">
div
  #access(v-if="has_permission")
    modal-shipment-claim(:detail="detail" :index="index")
    modal-received-date(:shipment-id="shipmentId")
    vm-row.heading(vm-w="12")
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12)
          div
            vm-button.separador-btn(icon="plus" @click="addShipment" v-if="shipments_store_permission && inOrder.status != 5") {{ $t('strings.add') }}
            //- vm-tooltip.separador-btn(:text="$t('strings.options')" delay=".5s")
            //-   vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
            //-     vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
            //-     vm-dropdown-menu
            //-       vm-dropdown-item.d-flex.justify-content-between(@click="")
            //-         vm-icon(icon="printer-outline")
            //-         slot &nbsp;{{ $t('strings.print') }}
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected" :data="shipments")
            template(slot="header")
              .d-flex.justify-content-between
                div
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
              vm-th
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  div(@click="editShipment(data[indextr], indextr)")
                    slot(v-if="column == 'total' || column == 'amount'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'created_at' || column == 'shipped_date' || column == 'received_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column != 'created_at' && column != 'shipped_date' && column != 'received_date' && column != 'status' && column != 'total' && column != 'amount'") {{data[indextr][column]}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="editShipment(data[indextr], indextr)" v-if="shipments_index_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.open') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="confirmDeleteShipment(data[indextr], indextr)" v-if="shipments_index_permission && !$auth.check('Customer')")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="addClaim(data[indextr], indextr)" v-if="claims_update_permission")
                        vm-icon(icon="alert-circle-outline")
                        slot &nbsp;{{ $t('strings.claim') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="addReceivedDate(data[indextr], indextr)")
                        vm-icon(icon="calendar-outline")
                        slot &nbsp;{{ $t('strings.received_date') }}
          .pagination
            vm-pagination(:total="paginationShipments.totalPages" v-model="currentPage" goto)
  #no-access(v-else)
    access-denied
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'Shipments',
  components: {
    ModalShipmentClaim: () => import('@/components/in-order/ModalShipmentClaim.vue'),
    ModalReceivedDate: () => import('@/components/in-order/ModalReceivedDate.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    selected: [],
    detail: {},
    remision: {},
    shipment: {},
    currentPage: 1,
    has_permission: true,
    shipments_index_permission: true,
    shipments_store_permission: true,
    claims_update_permission: true,
    shipments_update_permission: true,
    customer: true,
    index: null,
    columns: [
      'remission_number',
      'addressee',
      'shipped_date',
      'comments',
      'received_date',
      'created_at'
    ],
    shipmentId: ''
  }),
  watch: {
    currentPage (currentPage) {
      this.getShipments(currentPage)
    }
  },
  async created () {
    this.checkPermissionView('shipments.index')
    this.$route.params.id && await this.getShipments(1)
  },
  methods: {
    ...mapActions([
      'loadInOrder',
      'setModalShipmentClaimVisible',
      'setModalReceivedDateVisible',
      'deleteShipment',
      'loadShipments'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.shipments_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'shipments.index') > -1
      this.shipments_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'shipments.store') > -1
      this.shipments_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'shipments.update') > -1
      this.claims_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'claims.update') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    addShipment () {
      this.$router.push({ name: 'newShipment', params: { isAdd: true } })
    },
    addClaim (shipment, index) {
      this.detail = shipment
      this.index = index
      this.detail.date = moment().format('YYYY-MM-DD')
      this.setModalShipmentClaimVisible(true)
    },
    editShipment (shipment, index) {
      this.$router.push({ name: 'editShipment', params: { idshipment: shipment.id, isAdd: false } })
    },
    addReceivedDate (payload) {
      this.shipmentId = payload.id
      this.setModalReceivedDateVisible(true)
    },
    confirmDeleteShipment (payload, idx) {
      this.shipmentId = payload.id
      this.$vm.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Delete Shipment',
        text: 'Are you sure you want to delete this shipment?',
        accept: this.deleteShipmentAction
      })
    },
    deleteShipmentAction () {
      this.deleteShipment(this.shipmentId)
      this.shipmentId = ''
    },
    async getShipments (page) {
      this.loadShipments({ project_id: this.$route.params.id, page: page })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'shipments',
      'paginationShipments'
    ])
  }
}
</script>
<style lang="scss">
  .pagination {
    padding-bottom: 30px;
  }
  .separador-btn {
    margin: 10px 5px;
  }
  .filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
  }
  .con-vm-tooltip {
  display: inline-block;
  position: relative;
  }
  .vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
